import React, { useRef, useState } from "react";

import Icon from "@cayuse/shared-react.components.icon";

import styles from "./styles.css";

export const PersonSearchOption = ({ option, onExpandClicked, expandRef = {} }) => {
	const [ isExpanded, setIsExpanded ] = useState();
	const iconRef = useRef(null);
	const hasAdditionalInfo = option.email || option.title || option.profile;

	const handleClick = event => {
		if (event.target.textContent === "Collapse All" || event.target.id === "expnded") {
			iconRef.current.firstChild.firstChild.setAttribute("data-icon", "chevron-right");
			setIsExpanded(false);
		}
		if (event.target.textContent === "Expand All" || event.target.id === "collapsed") {
			iconRef.current.firstChild.firstChild.setAttribute("data-icon", "chevron-down");
			setIsExpanded(true);
		}
	};

	if(expandRef.current) {
		expandRef.current.addEventListener("click", handleClick);
	}

	const handleExpand = event => {
		event.stopPropagation();
		iconRef.current.firstChild.firstChild.setAttribute("data-icon", isExpanded ? "chevron-right" : "chevron-down");
		setIsExpanded(!isExpanded);
		onExpandClicked();
	};

	return (
		<div className={styles.optionContent}>
			<div className={styles.title} ref={iconRef}>
				{hasAdditionalInfo && <button onClick={handleExpand}><Icon className="person-search-toggle-icon" name="chevron-right" data-testid="toggle"/></button> }
				<span data-testid="person-name">{option.name}</span>
			</div>

			{hasAdditionalInfo && isExpanded && (
				<div className={styles.content}>
					<div data-testid="person-email">{option.email}</div>
					<div data-testid="person-association">{option?.title}</div>
					<div className={styles.profileTypes} data-testid="person-profile-types">{option?.profileTypes}</div>
				</div>
			)}
		</div>
	);
};
